import * as React from "react";

const SvgIcnHoldOffLarge = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <path
            d="M11 15.5v4.092C11 20.369 10.44 21 9.75 21h-2.5C6.56 21 6 20.37 6 19.592V18.5l5-3zm7-4v8.22c0 .707-.56 1.28-1.25 1.28h-2.5c-.69 0-1.25-.573-1.25-1.28V14.5l5-3zM7.25 3h2.5c.69 0 1.25.597 1.25 1.333V11l-5 3V4.333C6 3.597 6.56 3 7.25 3zm7 0h2.5c.69 0 1.25.558 1.25 1.247V7l-5 3V4.247C13 3.558 13.56 3 14.25 3zM3.59 17.067l16.454-9.5a.5.5 0 01.5.866l-16.454 9.5a.5.5 0 11-.5-.866z"
            fill="currentColor"
            stroke="none"
            strokeWidth={1}
            fillRule="evenodd"
        />
    </svg>
);

export default SvgIcnHoldOffLarge;
